import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserProfile } from '@/types/auth';

interface AuthState {
  // State
  token: string | null;
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  // Actions
  setAuth: (token: string, user: UserProfile) => void;
  clearAuth: () => void;
  updateUser: (user: Partial<UserProfile>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      // Initial state
      token: null,
      user: null,
      isAuthenticated: false,
      isLoading: true,

      // Actions
      setAuth: (token, user) => set({
        token,
        user,
        isAuthenticated: true,
        isLoading: false,
      }),

      clearAuth: () => set({
        token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      }),

      updateUser: (partial) => set((state) => ({
        user: state.user ? { ...state.user, ...partial } : null,
      })),
    }),
    {
      name: 'tda-auth',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
      }),
      onRehydrateStorage: () => (state) => {
        // Mark as not loading after rehydration
        if (state) {
          state.isLoading = false;
          state.isAuthenticated = !!state.token;
        }
      },
    }
  )
);
